module.exports = __webpack_public_path__ + "img/delRound.09269653.svg";